import { ShieldAlert } from 'lucide-react'
import { Link } from 'react-router'

import { ROLE_LABELS, useAuth } from '@/features/auth'
import { BrandArcs } from '@/shared/components/brand'
import { Button } from '@/shared/components/ui/button'

import { ROUTES } from '../router/routes'

/**
 * Se muestra cuando el usuario está autenticado pero no tiene el permiso
 * necesario para la sección que intentó abrir.
 *
 * Es distinta del login a propósito: mandar aquí a alguien con sesión válida
 * le dice claramente "sí sabemos quién eres, esto no es para tu rol", en vez
 * de hacerle creer que su sesión falló.
 */
export function ForbiddenPage() {
  const { user } = useAuth()

  return (
    <div className="bg-background relative flex min-h-screen flex-col items-center justify-center gap-5 overflow-hidden p-6 text-center">
      <BrandArcs
        corner="bottom-left"
        className="text-brand-gold/15 absolute -bottom-24 -left-24 size-[480px]"
      />

      <span className="bg-secondary text-primary flex size-16 items-center justify-center rounded-full">
        <ShieldAlert className="size-8" aria-hidden="true" />
      </span>

      <div className="space-y-1">
        <h1 className="font-serif text-2xl font-semibold">No tienes acceso a esta sección</h1>
        <p className="text-muted-foreground max-w-md text-sm">
          {user
            ? `Tu rol (${ROLE_LABELS[user.role]}) no incluye este permiso. Si crees que es un error, contacta al administrador.`
            : 'Inicia sesión para continuar.'}
        </p>
      </div>

      <Button asChild variant="outline">
        <Link to={ROUTES.ROOT}>Volver al inicio</Link>
      </Button>
    </div>
  )
}
